var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconAgenda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.437,
    height: 19,
    viewBox: "0 0 14.437 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Agenda",
    transform: "translate(-17.406 -7.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36194",
    "data-name": "Path 36194",
    d: "M30.187,8.373H26.209a1.682,1.682,0,0,0-3.17,0H19.062a1.659,1.659,0,0,0-1.656,1.656V24.6a1.659,1.659,0,0,0,1.656,1.656H30.186A1.659,1.659,0,0,0,31.843,24.6V10.029a1.658,1.658,0,0,0-1.656-1.656Zm-6.771.649V8.937a1.21,1.21,0,0,1,2.419,0v.085a1.14,1.14,0,0,0,1.139,1.139.666.666,0,0,1,.633.459l.262.8H21.381l.262-.8a.665.665,0,0,1,.633-.459,1.14,1.14,0,0,0,1.139-1.139Zm4.64,1.451a1.033,1.033,0,0,0-.06-.145h2.133V24.3H19.121V10.326h2.133a1.147,1.147,0,0,0-.06.145l-.364,1.109.225.311h7.14l.225-.311ZM31.369,24.6a1.185,1.185,0,0,1-1.183,1.183H19.062A1.185,1.185,0,0,1,17.879,24.6V10.029a1.185,1.185,0,0,1,1.183-1.183h3.883q0,.045,0,.09v.085a.666.666,0,0,1-.666.666,1.139,1.139,0,0,0-.592.165h-2.8l-.237.237V24.538l.237.237H30.365l.237-.237V10.09l-.237-.237h-2.8a1.137,1.137,0,0,0-.592-.165.666.666,0,0,1-.666-.666V8.937q0-.045,0-.09h3.883a1.185,1.185,0,0,1,1.183,1.183Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36195",
    "data-name": "Path 36195",
    d: "M44.775,36.1l.237-.237v-3.6l-.237-.237h-3.6l-.237.237v3.6l.237.237Zm-1.987-3.6h.379v.742h-.379Zm-1.372,0h.9v.978l.237.237H43.4l.237-.237V32.5h.9v3.123H41.415Z",
    transform: "translate(-18.352 -19.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36196",
    "data-name": "Path 36196",
    d: "M31.634,54.9l-.131-.131H29.62L29.383,55v1.882l.237.237H31.5l.237-.237V55.46l.512-.512-.335-.335Zm-.368.367-.6.6-.306-.306-.335.335.473.473h.335l.434-.434v.715H29.856V55.238h1.409Z",
    transform: "translate(-9.339 -36.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36197",
    "data-name": "Path 36197",
    d: "M45.941,57.678v.237h5.277v-.473H45.941Z",
    transform: "translate(-22.25 -39.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36198",
    "data-name": "Path 36198",
    d: "M45.941,61.955v.237h5.277v-.473H45.941Z",
    transform: "translate(-22.25 -42.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36199",
    "data-name": "Path 36199",
    d: "M45.941,72.787v.237h5.277v-.473H45.941Z",
    transform: "translate(-22.25 -50.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36200",
    "data-name": "Path 36200",
    d: "M45.941,77.064V77.3h5.277v-.473H45.941Z",
    transform: "translate(-22.25 -54.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36201",
    "data-name": "Path 36201",
    d: "M31.634,70.01l-.131-.131H29.62l-.237.237V72l.237.237H31.5L31.739,72V70.573l.512-.512-.335-.335Zm-.368.367-.6.6-.306-.306-.335.335.473.473h.335l.434-.434v.715H29.856V70.352h1.409Z",
    transform: "translate(-9.339 -48.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36202",
    "data-name": "Path 36202",
    d: "M47.71,13.258a.7.7,0,1,0-.7-.7A.7.7,0,0,0,47.71,13.258Zm0-.923a.225.225,0,1,1-.225.225A.225.225,0,0,1,47.71,12.335Z",
    transform: "translate(-23.085 -3.594)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconAgenda);
export default __webpack_public_path__ + "static/media/Menu_Icon_Agenda.f57f6b93.svg";
export { ForwardRef as ReactComponent };